import {
    Button,
    Grid,
    Box,
    IconButton,
    Stack,
    Typography,
    TextField as MuiTextField,
    Radio,
    Input
  } from '@mui/material';
  import { useForm } from 'react-hook-form';
  import CloseIcon from '@mui/icons-material/Close';
  import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
  import { useCallback, useEffect, useState } from 'react';
  import { yupResolver } from '@hookform/resolvers/yup';
  import * as Yup from 'yup';
  import { dropdownFetch } from '../../../../../utils';
  import axios from 'axios';
  import { BASE_URL } from '../../../../../utils';
  const TABLE_HEADER = [
    {
      header: 'Service Name',
      accessor: (row) => row?.serviceData?.service_name || row?.testData?.test_name
    }
  ];
  
  const TEST_TABLE_HEADER = [
    {
      header: 'Service Name',
      accessor: (row) => row?.serviceData?.service_name || row?.testData?.test_name
    }
  ];
  
  export const InvestigationBookingDetailsForm = ({ onClose, doctorID, sponsorID, onAdd }) => {
    const [doctorDropdown, setDoctorDropdown] = useState([]);
    const [filteredServiceList, setFilteredServiceList] = useState([]);
    const [input, setInput] = useState('');
    const [priceListDropdown, setPriceListDropdown] = useState([]);
    const [LabpriceListDropdown, setLabPriceListDropdown] = useState([]);
    const [currentAction, setCurrentAction] = useState();
    const [selectedServiceRadio, setSelectedServiceRadio] = useState('service');
    const [selectedRadio, setSelectedRadio] = useState('');
    const [pagination, setPagination] = useState({
      currentPage: 1,
      totalPages: 1,
      totalCount: 0,
      limit: 10
    });
  
    useEffect(() => {
      console.log('HELLLO THE SPONSOR IS HERE', sponsorID);
    }, [sponsorID]);
  
    const getTestDropdown = useCallback(async () => {
      const response = await axios.get(`${BASE_URL}/lab-price-list-master/list?&sponsorName=${sponsorID}`);
      console.log(response.data.data);
      setLabPriceListDropdown(response.data.data);
    }, [sponsorID]);
  
    const getServiceDropdown = useCallback(async () => {
      const response = await axios.get(`${BASE_URL}/price-list-master/list?&sponsorName=${sponsorID}`);
      console.log(response.data.data);
      setPriceListDropdown(response.data.data);
    }, [sponsorID]);
    // Function to merge serviceDropdown and testDropdown data
    const mergeDropdowns = useCallback(() => {}, [priceListDropdown, LabpriceListDropdown]);
  
    const getDoctorDropdown = useCallback(async () => {
      const data = await dropdownFetch('doctor');
      setDoctorDropdown(data);
    }, []);
  
    useEffect(() => {
      getServiceDropdown();
      getTestDropdown();
    }, [sponsorID]);
  
    useEffect(() => {
      getDoctorDropdown();
    }, [getDoctorDropdown]);
  
    const methods = useForm({
      resolver: yupResolver(
        Yup.object().shape({
          doctor: Yup.string().required('Please select Doctor'),
          service: Yup.string().required('Please select Service')
        })
      ),
      defaultValues: {
        doctor: doctorID || '',
        service: '',
        quantity: 1,
        rate: 0,
        amount: 0,
        net_amt: 0,
        gst_amt: 0,
        disc_amt: 0,
        disc_per: 0,
        gst_per: 0
      },
      mode: 'all'
    });
    const { reset } = methods;
  
    const { handleSubmit, setValue, watch } = methods;
  
    const formSubmitHandler = (formValues) => {
      console.log(formValues);
      formValues.gst_per = +formValues.gst_per;
      formValues.disc_per = +formValues.disc_per;
      formValues.quantity = +formValues.quantity;
      const doctorName = doctorDropdown.find(({ _id }) => _id === formValues.doctor)?.name || '';
      const transformedValues = {
        ...formValues,
        doctor: doctorName
      };
      console.log('HELLLO TRANSFORMED VALUES', transformedValues);
      onAdd(transformedValues);
    };
  
    const handleServiceSelection = (row) => {
      console.log(row, 'HELLLO ROWSSSS IS HERE ');
      methods.resetField('service');
      setValue(
        'rate',
        row?.inputValues[0]['NABH Ipd Char'] > 0
          ? row?.inputValues[0]['NABH Ipd Char']
          : row?.inputValues[0]['Ipd Charge'] || 0
      );
  
      setValue('serviceName', row?.serviceData?.service_name || row?.testData?.test_name);
      setValue('service', row?.serviceData?._id || row?.testData?._id);
      setValue('type', row?.serviceData?.type || row?.testData?.type);
    };
  
    const rateWatch = watch('rate');
    const quantityWatch = watch('quantity');
    const discPerWatch = watch('disc_per');
    const gstPerWatch = watch('gst_per');
    const discAmtWatch = watch('disc_amt');
  
    useEffect(() => {
      const amount = rateWatch * quantityWatch;
      const discAmt = parseFloat(((amount * discPerWatch) / 100).toFixed(2));
      const gstAmt = parseFloat((((amount - discAmt) * gstPerWatch) / 100).toFixed(2));
      const netAmt = parseFloat((amount - discAmt + gstAmt).toFixed(2));
      setValue('amount', parseFloat(amount.toFixed(2)));
      setValue('disc_amt', discAmt);
      setValue('gst_amt', gstAmt);
      setValue('net_amt', netAmt);
    }, [rateWatch, quantityWatch, discPerWatch, gstPerWatch, setValue]);
  
    useEffect(() => {
      if (rateWatch && quantityWatch && discAmtWatch !== undefined) {
        const amount = rateWatch * quantityWatch;
        const newDiscPer = parseFloat(((discAmtWatch / amount) * 100).toFixed(6));
        setValue('disc_per', newDiscPer);
      }
    }, [rateWatch, quantityWatch, discAmtWatch, setValue]);
  
    // useEffect(() => {
    //   const filtered = mergeDropdowns().filter((item) => item.name.toLowerCase().includes(input.toLowerCase()));
    //   setFilteredServiceList(filtered);
    // }, [input, mergeDropdowns]);
  
    const getTestDropdownn = useCallback(async () => {
      const response = await axios.get(
        `${BASE_URL}/lab-price-list-master/list?&sponsorName=${sponsorID}&testName=${input}`
      );
      console.log(response.data.data);
      setLabPriceListDropdown(response.data.data);
    }, [sponsorID, input]);
  
    const getServiceDropdownn = useCallback(async () => {
      const response = await axios.get(
        `${BASE_URL}/price-list-master/list?&sponsorName=${sponsorID}&serviceName=${input}`
      );
      console.log(response.data.data);
      setPriceListDropdown(response.data.data);
    }, [sponsorID, input]);
  
    useEffect(() => {
      if (selectedServiceRadio === 'service') {
        getServiceDropdownn();
      } else {
        getTestDropdownn();
      }
    }, [input]);
  
    const handleInputChange = (e) => {
      console.log(e.target.value);
      setInput(e.target.value);
    };
  
    const handleRadioChange = (event) => {
      const { name } = event.target;
      setSelectedServiceRadio(name);
    };
    return (
      <Stack spacing={1} sx={{ height: '100%' }}>
        <Stack
          padding={1.5}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Add Invoice Details
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
          <MuiTextField
            sx={{ width: '100%', padding: 0, font: '32px' }}
            label="Search Service"
            variant="outlined"
            value={input}
            onChange={handleInputChange}
            InputProps={{
              style: {
                fontSize: '14px',
                fontWeight: 600
              }
            }}
          />
        </Stack>
        <FormProvider
          sx={{ height: '100%', overflow: 'auto' }}
          methods={methods}
          onSubmit={handleSubmit(formSubmitHandler)}
        >
          <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
            <Grid
              item
              xs={6}
              sx={{
                height: '100%',
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
                gap: 1
              }}
            >
              <Stack spacing={0.2} direction="row" alignItems="center">
                <Radio
                  sx={{
                    flex: 0.3
                  }}
                  name="service"
                  checked={selectedServiceRadio === 'service'}
                  onChange={handleRadioChange}
                />
                <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>Service</Typography>
                <Radio
                  sx={{
                    flex: 0.2
                  }}
                  name="lab"
                  checked={selectedServiceRadio === 'lab'}
                  onChange={handleRadioChange}
                />
                <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>Lab</Typography>
              </Stack>
              {selectedServiceRadio === 'service' ? (
                <Table
                  containerSX={{
                    flex: 1,
                    border: '0px solid rgba(0,0,0,0.27)',
                    minHeight: '48rem',
                    borderRadius: 1
                  }}
                  data={priceListDropdown || []}
                  columns={TABLE_HEADER}
                  size="small"
                  onRowClick={(row) => {
                    handleServiceSelection(row);
                  }}
                />
              ) : (
                <Table
                  containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)', minHeight: '48rem' }}
                  data={LabpriceListDropdown || []}
                  columns={TEST_TABLE_HEADER}
                  size="small"
                  onRowClick={(row) => {
                    handleServiceSelection(row);
                  }}
                />
              )}
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2, px: 2 }}>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Operating Doctor</Typography>
                  <SelectTag
                    formControlSX={{ flex: 0.8 }}
                    menus={doctorDropdown}
                    name="doctor"
                    placeholder="Select Doctor"
                  />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Service</Typography>
                  <TextField sx={{ flex: 0.8 }} disabled name="serviceName" placeholder="Select Service" />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Quantity</Typography>
                  <TextField
                    sx={{ flex: 0.3 }}
                    type="number"
                    inputProps={{ min: '0' }}
                    name="quantity"
                    placeholder="Quantity"
                  />
                  <Typography sx={{ flex: 0.1, fontWeight: 700, fontSize: '1.4rem' }}>Rate</Typography>
                  <TextField sx={{ flex: 0.35 }} name="rate" placeholder="Rate" />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Amount</Typography>
                  <TextField sx={{ flex: 0.8 }} name="amount" disabled placeholder="amount" />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Disc. Auth</Typography>
                  <TextField sx={{ flex: 0.8 }} name="disc_auth" placeholder="Select Disc. Auth" />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Disc. Type</Typography>
                  <TextField sx={{ flex: 0.8 }} name="disc_type" placeholder="Disc. Type" />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Disc. Per</Typography>
                  <TextField
                    sx={{ flex: 0.3 }}
                    name="disc_per"
                    type="number"
                    inputProps={{ min: '0', max: '100', step: '0.000001' }} // step set for high precision
                    placeholder="Disc. Per"
                  />
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Disc. Amt</Typography>
                  <TextField sx={{ flex: 0.3 }} name="disc_amt" type="number" placeholder="Disc. Amt" />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Net Amount</Typography>
                  <TextField
                    sx={{ flex: 0.8 }}
                    name="net_amt"
                    type="number"
                    disabled
                    inputProps={{ min: '0' }}
                    placeholder="Net Amount"
                  />
                </Stack>
                <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
                  <Button variant="contained" type="submit">
                    Add
                  </Button>
                  <Button variant="outlined" onClick={onClose} color="error">
                    Close
                  </Button>
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </FormProvider>
      </Stack>
    );
  };
  